import { request } from './api/request'
import { wrapper } from './api/index'
import router from '@/router/index'
import WX_API from './wx_api'

let toast_el
let preview_el
let preview_img_el
let preview_overlay_el
let loading_el

const checkTfsm = () => {
    return navigator.userAgent.toLowerCase().indexOf('tfsmy') > -1
}

const checkTfBank = () => {
    const { VUE_APP_TYPE } = process.env
    return VUE_APP_TYPE === 'tf-bank'
}

const stop_move_class = ['overlay', 'no-scroll']

document.addEventListener('touchmove', function (e) {
    const stop_move = stop_move_class.some((classname) => {
        return e.target.className.indexOf(classname) > -1
    })
    if(stop_move) {
        e.preventDefault()
    } else {
        e.stopPropagation()
    }
}, { passive: false })

const showToast = (opt) => {
    const { title, duration, icon } = opt
    if (toast_el) {
        toast_el.innerHTML = title
        toast_el.style.display = 'block'
    } else {
        toast_el = document.createElement('div')
        toast_el.innerHTML = title
        toast_el.className = 'wx-toast'
        document.body.appendChild(toast_el)
    }
    setTimeout(() => {
        toast_el.style.display = 'none'
    }, duration || 1800)
}


const copyByDomId = (id, name) => {
    let target = null;

    if (name) {
        target = document.createElement('div');
        target.id = 'tempTarget';
        target.style.opacity = '0';
        if (id) {
            let curNode = document.querySelector('#' + id);
            target.innerText = curNode.dataset[name];
        } else {
            target.innerText = attr;
        }
        document.body.appendChild(target);
    } else {
        target = document.querySelector('#' + id);
    }

    try {
        let range = document.createRange();
        range.selectNode(target);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        showToast({
            title: '复制成功'
        })
    } catch (e) {
        console.log('复制失败')
    }

    if (name) {
        // remove temp target
        target.parentElement.removeChild(target);
    }
}

export default {
    copyByDomId,
    showToast,
    hideToast () {
        if (toast_el) {
            toast_el.style.display = 'none'
        }
    },
    hidePreviewImage () {
        if (preview_el) {
            preview_el.style.display = 'none'
        }
        if (preview_overlay_el) {
            preview_overlay_el.style.display = 'none'
        }
    },
    request: wrapper('request', request),
    previewImage ({ current }) {
        if (preview_el) {
            preview_img_el.src = current
            preview_el.style.display = 'block'
            preview_overlay_el.style.display = 'block'
        } else {
            preview_el = document.createElement('div')
            preview_el.className = 'wx-dlg no-scroll'
            preview_el.style.position = 'fixed'
            preview_el.style.top = '50%'
            preview_el.style.left = '50%'
            preview_el.style.transform = 'translate(-50%, -50%)'
            preview_el.style.width = '80%'
            preview_el.style.maxHeight = '100%'
            preview_el.style.height = 'auto'
            preview_el.style.overflow = 'scroll'

            preview_img_el = document.createElement('img')
            preview_img_el.style.display = 'block'
            preview_img_el.style.width = '100%'
            preview_img_el.style.height = 'auto'
            preview_img_el.style.margin = '0 auto'
            preview_img_el.src = current
            preview_el.appendChild(preview_img_el)

            preview_overlay_el = document.createElement('div')
            preview_overlay_el.className = 'overlay'
            document.body.appendChild(preview_overlay_el)

            preview_overlay_el.addEventListener('click', function (e) {
                preview_overlay_el.style.display = 'none'
                preview_el.style.display = 'none'
            }, false)
            document.body.appendChild(preview_el)
        }
    },
    showLoading () {

    },
    hideLoading () {

    },
    makePhoneCall ({ phoneNumber, success }) {
        console.log(arguments)
        if (checkTfsm()) {
            eshimin.phoneCall({ num: phoneNumber, onResponse: success })
        } else {
            console.error('phone', phoneNumber)
            window.location.href = `tel:${phoneNumber}`
            success()
        }
    },
    downloadImg ({ url, name = '', success = () => {} }) {
        if (checkTfsm()) {
            url = url.replace(/data:image\/\w+;base64,/, '')
            eshimin.saveImage({
                imgStr: url,
                onResponse: (res) => {
                    res = JSON.parse(res)
                    if (Number(res.code) === 200) {
                        success()
                    }
                }
            })
            return
        }
        if (checkTfBank() && tf && tf.photo) {
            tf.photo.saveImageToAlbum({
                photo: url.replace(/data:image\/\w+;base64,/, '')
            }).then((data) => {
                success()
            }).catch((err) => {
                console.error('save img error', err)
            })
            return
        }
        const a = document.createElement('a')
        a.download = name
        a.href = url
        a.click()
        success()
    },
    navigateTo({ url }) {
        router.push({
            path: url
        })
    },
    redirectTo({ url }) {
        router.replace({
            path: url
        })
    },
    navigateBack ({ detal = 1}) {
        router.go(-detal)
    },
    getSystemInfoSync() {
        const windowWidth = document.documentElement.clientWidth
        const system = navigator.userAgent.toLowerCase()
        const pixelRatio = window.devicePixelRatio
        return {
            windowWidth,
            system,
            pixelRatio
        }
    }
}